import React, { Fragment } from "react";
import {
  ToggleButtonGroup,
  MainNavItem,
  Button,
  Flex,
  Text,
  useToggleButtonContext
} from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";
import cx from "classnames";

export const PositionEditorLeftSidebar = ({
  isExpanded,
  onToggleExpand,
  selectedMode,
  onModeChange,
  children,
  availableModes = [
    {
      value: "budget",
      icon: "chart-mixed-up-circle-dollar",
      header: appstr("Budget details"),
      hovertip: appstr("View budget information")
    }
  ],
  dataTestIdPrefix = "position-editor-left-sidebar"
}) => {
  const toolbarContent = (
    <Fragment>
      <ToggleButtonGroup
        value={isExpanded ? selectedMode : ""}
        onChange={value => onModeChange(value[0] || value)}
        exclusive={true}
        enforceValueSet={false}
        spacing={12}
        orientation={"vertical"}
      >
        {availableModes.map(item => (
          <ToggleMainNavItem
            key={item.value}
            color={"primary"}
            value={item.value}
            icon={item.icon}
            size={"large"}
            label={appstr(item.header)}
            tooltipProps={{
              message: item.hovertip,
              position: "left"
            }}
            dataTestId={`${dataTestIdPrefix}-toggle-${item.value}`}
          />
        ))}
      </ToggleButtonGroup>
    </Fragment>
  );

  return (
    <aside className="position-editor-sidebar-container" tabIndex="-1">
      <div
        className={cx("position-editor-sidebar", {
          "position-editor-sidebar-expanded": isExpanded,
          "position-editor-sidebar-collapsed": !isExpanded
        })}
      >
        <div className="position-editor-sidebar-toolbar">
          <div className="position-editor-sidebar-toolbar-content">{toolbarContent}</div>
        </div>
        {isExpanded && (
          <Flex height={"100%"} direction={"column"}>
            <Flex justifyContent={"space-between"} style={{ padding: "16px" }}>
              <Text size={"large"}>{"Budget details"}</Text>
              <Button
                iconOnly
                modifier={"tertiary"}
                iconProps={{ name: "xmark" }}
                onClick={onToggleExpand}
                size="large"
                tooltipProps={{
                  message: appstr("Hide details"),
                  position: "right"
                }}
                dataTestId={`${dataTestIdPrefix}-toggle-expand`}
              />
            </Flex>
            <div className={cx("position-editor-sidebar-content", "ocn-list-scrollbar")}>
              {children}
            </div>
          </Flex>
        )}
      </div>
    </aside>
  );
};

const ToggleMainNavItem = ({ value, ...rest }) => {
  const { checked: contextChecked, handleToggleChange } = useToggleButtonContext(value);

  return (
    <MainNavItem {...rest} checked={contextChecked} onToggle={() => handleToggleChange(value)} />
  );
};
